import { useTranslation } from 'react-i18next';
import { withBase } from '@/constants';

interface MobileCTAProps {
  /** Optional anchor target (defaults to the home contact section). */
  href?: string;
  /** Optional i18n key for the button label. */
  labelKey?: string;
}

export default function MobileCTA({
  href = withBase('/#iletisim'),
  labelKey = 'mobile.cta',
}: MobileCTAProps) {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-primary-500/20 bg-foreground-950/98 backdrop-blur-md p-3 md:hidden">
      <a
        href={href}
        className="block w-full whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-center text-sm font-semibold text-foreground-950"
      >
        {t(labelKey)}
      </a>
    </div>
  );
}